export const RUBICS_CUBE_COLUMNS = {
  ACTIVE_COLUMN: 'active',
  API_NAME_COLUMN: 'api_name',
  API_VERSION_COLUMN: 'api_version',
  ASSIGNED_USERS_COLUMN: 'assigned_users',
  ASYNC_RUN_COLUMN: 'async_run',
  BASE_OBJECT_COLUMN: 'base_object',
  COMPLEXITY_SCORE_LEVEL_COLUMN: 'complexity_score_level',
  CREATED_DATE_COLUMN: 'created_date',
  FAULT_COVERAGE_COLUMN: 'fault_coverage',
  FULL_API_NAME_COLUMN: 'full_api_name',
  IMMEDIATE_RUN_COLUMN: 'immediate_run',
  LAST_CREATED_RECORD_DATE_COLUMN: 'last_created_record_date',
  LAST_MODIFIED_BY_COLUMN: 'last_modified_by',
  LAST_MODIFIED_DATE_COLUMN: 'last_modified_date',
  LAST_MODIFIED_RECORD_DATE_COLUMN: 'last_modified_record_date',
  LAST_REPORT_RUN_DATE_COLUMN: 'last_report_run_date',
  NAME_COLUMN: 'name',
  RECORD_COUNT_COLUMN: 'record_count',
  STATUS_COLUMN: 'status',
  SUBTYPE_COLUMN: 'subtype',
  SUMMARY_INFO_OBJECT_COLUM: 'summary_info_objects',
  TEST_COVERAGE_COLUMN: 'test_coverage',
  TOTAL_COMPLEXITY_COLUMN: 'total_complexity',
  TRIGGER_TYPE_COLUMN: 'trigger_type',
  TRIGGER_ORDER_COLUMN: 'trigger_order',
  TYPE_COLUMN: 'type',
  FULL_PATH: 'full_path',
  ENCRYPTION_SCHEME: 'encryption_scheme',
  BUSINESS_STATUS: 'business_status',
  DATA_OWNER: 'data_owner',
  COMPLIANCE_GROUP: 'compliance_group',
  DATA_SENSITIVITY: 'data_sensitivity',
  LENGTH: 'length',
  ENCRYPTED: 'encrypted',
  REQUIRED: 'required',
  PARENT_OBJECT: 'parent_object',
  PARENT_MANAGE_PACKAGE: 'parent_manage_package',
  TAGS: 'tags',
  PRODUCT_NAME_COLUMN: 'product_name',
  PRODUCT_FAMILY_COLUMN: 'product_family',
  PRODUCT_CODE_COLUMN: 'product_code',
  PRODUCT_SKU_COLUMN: 'product_sku'
} as const;

export type TRubicCubeColumn = keyof typeof RUBICS_CUBE_COLUMNS;
export type TRubicCubeValue = (typeof RUBICS_CUBE_COLUMNS)[TRubicCubeColumn] | string;

export interface ICSSInlineStyles {
  [key: string]: string;
}

export type TCSSClasses = string | string[];

export type TStatusColumnValue =
  | 'new'
  | 'unchanged'
  | 'updated'
  | 'deleted'
  | 'excluded'
  | 'proposed';
export type TStatusStyleClass = 'secondary' | 'success' | 'danger' | 'warning';

export interface IColumnStyles {
  classes?: TCSSClasses | undefined;
  inlineStyles?: ICSSInlineStyles | undefined;
}
